export const environment = {
  production: true,
  baseUrl: '/',
  apiUrl: '/applicationrequester/v1/',
  path: '',
  keycloakUrl: 'https://tp-portaal.taf.nl/auth',
  keycloakRealm: 'TP',
  keycloakClientId: 'application-requester-frontend'
};
